(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8623],{

/***/ 5855:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/aboutus",
      function () {
        return __webpack_require__(43898);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 43898:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _components_Navbar__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(84075);


var AboutUsPage = function() {
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Navbar__WEBPACK_IMPORTED_MODULE_1__/* .Navbar */ .w, {
        position: "sticky"
    }));
};
/* harmony default export */ __webpack_exports__["default"] = (AboutUsPage);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [1228,2013,4617,3874,994,296,3894,4,6876,2036,9876,1740,4075,9774,2888,179], function() { return __webpack_exec__(5855); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);